module.exports = __webpack_public_path__ + "img/openGame.b8e67fcd.png";